exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-content[data-v-b2c566ca] {\n  width: 100%;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n.colored[data-v-b2c566ca] {\n  background: #f5f7f9;\n}\n", ""]);

// exports
